// extracted by mini-css-extract-plugin
export var actionButton = "_dm-0";
export var attachmentLine = "_dm-1";
export var fileInput = "_dm-2";
export var fileUploadWrapper = "_dm-4";
export var footer = "_dm-3";
export var modalContent = "_dm-5";
export var paperclip = "_dm-6";
export var quillEditor = "_dm-7";